import * as antlr from "antlr4ng";

import { RuleGrammarVisitor } from "./RuleGrammarVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI

type int = number;

export class RuleGrammarParser extends antlr.Parser {
  public static readonly COMPARE_OP = 1;
  public static readonly PLUS = 2;
  public static readonly MINUS = 3;
  public static readonly STAR = 4;
  public static readonly SLASH = 5;
  public static readonly LPAREN = 6;
  public static readonly RPAREN = 7;
  public static readonly TAG = 8;
  public static readonly NUMBER = 9;
  public static readonly WS = 10;
  public static readonly INVALID = 11;
  public static readonly RULE_script = 0;
  public static readonly RULE_parenScript = 1;
  public static readonly RULE_comparison = 2;
  public static readonly RULE_arithmeticExpr = 3;
  public static readonly RULE_signedAtom = 4;
  public static readonly RULE_term = 5;
  public static readonly RULE_factor = 6;
  public static readonly RULE_primary = 7;

  public static readonly literalNames = [null, null, "'+'", "'-'", "'*'", "'/'", "'('", "')'"];

  public static readonly symbolicNames = [
    null,
    "COMPARE_OP",
    "PLUS",
    "MINUS",
    "STAR",
    "SLASH",
    "LPAREN",
    "RPAREN",
    "TAG",
    "NUMBER",
    "WS",
    "INVALID",
  ];
  public static readonly ruleNames = [
    "script",
    "parenScript",
    "comparison",
    "arithmeticExpr",
    "signedAtom",
    "term",
    "factor",
    "primary",
  ];

  public get grammarFileName(): string {
    return "RuleGrammar.g4";
  }

  public get literalNames(): (string | null)[] {
    return RuleGrammarParser.literalNames;
  }

  public get symbolicNames(): (string | null)[] {
    return RuleGrammarParser.symbolicNames;
  }

  public get ruleNames(): string[] {
    return RuleGrammarParser.ruleNames;
  }

  public get serializedATN(): number[] {
    return RuleGrammarParser._serializedATN;
  }

  protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
    return new antlr.FailedPredicateException(this, predicate, message);
  }

  public constructor(input: antlr.TokenStream) {
    super(input);
    this.interpreter = new antlr.ParserATNSimulator(
      this,
      RuleGrammarParser._ATN,
      RuleGrammarParser.decisionsToDFA,
      new antlr.PredictionContextCache()
    );
  }

  public script(): ScriptContext {
    let localContext = new ScriptContext(this.context, this.state);
    this.enterRule(localContext, 0, RuleGrammarParser.RULE_script);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 16;
        this.parenScript();
        this.state = 17;
        this.match(RuleGrammarParser.EOF);
      }
    } catch (re) {
      if (re instanceof antlr.RecognitionException) {
        this.errorHandler.reportError(this, re);
        this.errorHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }

  public parenScript(): ParenScriptContext {
    let localContext = new ParenScriptContext(this.context, this.state);
    this.enterRule(localContext, 2, RuleGrammarParser.RULE_parenScript);
    try {
      this.state = 24;
      this.errorHandler.sync(this);
      switch (this.interpreter.adaptivePredict(this.tokenStream, 0, this.context)) {
        case 1:
          this.enterOuterAlt(localContext, 1);
          {
            this.state = 19;
            this.match(RuleGrammarParser.LPAREN);
            this.state = 20;
            this.parenScript();
            this.state = 21;
            this.match(RuleGrammarParser.RPAREN);
          }
          break;
        case 2:
          this.enterOuterAlt(localContext, 2);
          {
            this.state = 23;
            this.comparison();
          }
          break;
      }
    } catch (re) {
      if (re instanceof antlr.RecognitionException) {
        this.errorHandler.reportError(this, re);
        this.errorHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }

  public comparison(): ComparisonContext {
    let localContext = new ComparisonContext(this.context, this.state);
    this.enterRule(localContext, 4, RuleGrammarParser.RULE_comparison);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 26;
        this.arithmeticExpr();
        this.state = 27;
        this.match(RuleGrammarParser.COMPARE_OP);
        this.state = 28;
        this.arithmeticExpr();
      }
    } catch (re) {
      if (re instanceof antlr.RecognitionException) {
        this.errorHandler.reportError(this, re);
        this.errorHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }

  public arithmeticExpr(): ArithmeticExprContext {
    let localContext = new ArithmeticExprContext(this.context, this.state);
    this.enterRule(localContext, 6, RuleGrammarParser.RULE_arithmeticExpr);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 30;
        this.signedAtom();
      }
    } catch (re) {
      if (re instanceof antlr.RecognitionException) {
        this.errorHandler.reportError(this, re);
        this.errorHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }

  public signedAtom(): SignedAtomContext {
    let localContext = new SignedAtomContext(this.context, this.state);
    this.enterRule(localContext, 8, RuleGrammarParser.RULE_signedAtom);
    try {
      this.state = 35;
      this.errorHandler.sync(this);
      switch (this.tokenStream.LA(1)) {
        case RuleGrammarParser.MINUS:
          this.enterOuterAlt(localContext, 1);
          {
            this.state = 32;
            this.match(RuleGrammarParser.MINUS);
            this.state = 33;
            this.term();
          }
          break;
        case RuleGrammarParser.LPAREN:
        case RuleGrammarParser.TAG:
        case RuleGrammarParser.NUMBER:
          this.enterOuterAlt(localContext, 2);
          {
            this.state = 34;
            this.term();
          }
          break;
        default:
          throw new antlr.NoViableAltException(this);
      }
    } catch (re) {
      if (re instanceof antlr.RecognitionException) {
        this.errorHandler.reportError(this, re);
        this.errorHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }

  public term(): TermContext {
    let localContext = new TermContext(this.context, this.state);
    this.enterRule(localContext, 10, RuleGrammarParser.RULE_term);
    let _la: number;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 37;
        this.factor();
        this.state = 42;
        this.errorHandler.sync(this);
        _la = this.tokenStream.LA(1);
        while (_la === 2 || _la === 3) {
          {
            {
              this.state = 38;
              _la = this.tokenStream.LA(1);
              if (!(_la === 2 || _la === 3)) {
                this.errorHandler.recoverInline(this);
              } else {
                this.errorHandler.reportMatch(this);
                this.consume();
              }
              this.state = 39;
              this.factor();
            }
          }
          this.state = 44;
          this.errorHandler.sync(this);
          _la = this.tokenStream.LA(1);
        }
      }
    } catch (re) {
      if (re instanceof antlr.RecognitionException) {
        this.errorHandler.reportError(this, re);
        this.errorHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }

  public factor(): FactorContext {
    let localContext = new FactorContext(this.context, this.state);
    this.enterRule(localContext, 12, RuleGrammarParser.RULE_factor);
    let _la: number;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 45;
        this.primary();
        this.state = 50;
        this.errorHandler.sync(this);
        _la = this.tokenStream.LA(1);
        while (_la === 4 || _la === 5) {
          {
            {
              this.state = 46;
              _la = this.tokenStream.LA(1);
              if (!(_la === 4 || _la === 5)) {
                this.errorHandler.recoverInline(this);
              } else {
                this.errorHandler.reportMatch(this);
                this.consume();
              }
              this.state = 47;
              this.primary();
            }
          }
          this.state = 52;
          this.errorHandler.sync(this);
          _la = this.tokenStream.LA(1);
        }
      }
    } catch (re) {
      if (re instanceof antlr.RecognitionException) {
        this.errorHandler.reportError(this, re);
        this.errorHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }

  public primary(): PrimaryContext {
    let localContext = new PrimaryContext(this.context, this.state);
    this.enterRule(localContext, 14, RuleGrammarParser.RULE_primary);
    try {
      this.state = 59;
      this.errorHandler.sync(this);
      switch (this.tokenStream.LA(1)) {
        case RuleGrammarParser.TAG:
          this.enterOuterAlt(localContext, 1);
          {
            this.state = 53;
            this.match(RuleGrammarParser.TAG);
          }
          break;
        case RuleGrammarParser.NUMBER:
          this.enterOuterAlt(localContext, 2);
          {
            this.state = 54;
            this.match(RuleGrammarParser.NUMBER);
          }
          break;
        case RuleGrammarParser.LPAREN:
          this.enterOuterAlt(localContext, 3);
          {
            this.state = 55;
            this.match(RuleGrammarParser.LPAREN);
            this.state = 56;
            this.arithmeticExpr();
            this.state = 57;
            this.match(RuleGrammarParser.RPAREN);
          }
          break;
        default:
          throw new antlr.NoViableAltException(this);
      }
    } catch (re) {
      if (re instanceof antlr.RecognitionException) {
        this.errorHandler.reportError(this, re);
        this.errorHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }

  public static readonly _serializedATN: number[] = [
    4, 1, 11, 62, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2, 6, 7, 6, 2, 7, 7, 7, 1, 0,
    1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 25, 8, 1, 1, 2, 1, 2, 1, 2, 1, 2, 1, 3, 1, 3, 1, 4, 1, 4, 1, 4, 3,
    4, 36, 8, 4, 1, 5, 1, 5, 1, 5, 5, 5, 41, 8, 5, 10, 5, 12, 5, 44, 9, 5, 1, 6, 1, 6, 1, 6, 5, 6, 49, 8, 6, 10, 6, 12,
    6, 52, 9, 6, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 3, 7, 60, 8, 7, 1, 7, 0, 0, 8, 0, 2, 4, 6, 8, 10, 12, 14, 0, 2, 1,
    0, 2, 3, 1, 0, 4, 5, 59, 0, 16, 1, 0, 0, 0, 2, 24, 1, 0, 0, 0, 4, 26, 1, 0, 0, 0, 6, 30, 1, 0, 0, 0, 8, 35, 1, 0, 0,
    0, 10, 37, 1, 0, 0, 0, 12, 45, 1, 0, 0, 0, 14, 59, 1, 0, 0, 0, 16, 17, 3, 2, 1, 0, 17, 18, 5, 0, 0, 1, 18, 1, 1, 0,
    0, 0, 19, 20, 5, 6, 0, 0, 20, 21, 3, 2, 1, 0, 21, 22, 5, 7, 0, 0, 22, 25, 1, 0, 0, 0, 23, 25, 3, 4, 2, 0, 24, 19, 1,
    0, 0, 0, 24, 23, 1, 0, 0, 0, 25, 3, 1, 0, 0, 0, 26, 27, 3, 6, 3, 0, 27, 28, 5, 1, 0, 0, 28, 29, 3, 6, 3, 0, 29, 5,
    1, 0, 0, 0, 30, 31, 3, 8, 4, 0, 31, 7, 1, 0, 0, 0, 32, 33, 5, 3, 0, 0, 33, 36, 3, 10, 5, 0, 34, 36, 3, 10, 5, 0, 35,
    32, 1, 0, 0, 0, 35, 34, 1, 0, 0, 0, 36, 9, 1, 0, 0, 0, 37, 42, 3, 12, 6, 0, 38, 39, 7, 0, 0, 0, 39, 41, 3, 12, 6, 0,
    40, 38, 1, 0, 0, 0, 41, 44, 1, 0, 0, 0, 42, 40, 1, 0, 0, 0, 42, 43, 1, 0, 0, 0, 43, 11, 1, 0, 0, 0, 44, 42, 1, 0, 0,
    0, 45, 50, 3, 14, 7, 0, 46, 47, 7, 1, 0, 0, 47, 49, 3, 14, 7, 0, 48, 46, 1, 0, 0, 0, 49, 52, 1, 0, 0, 0, 50, 48, 1,
    0, 0, 0, 50, 51, 1, 0, 0, 0, 51, 13, 1, 0, 0, 0, 52, 50, 1, 0, 0, 0, 53, 60, 5, 8, 0, 0, 54, 60, 5, 9, 0, 0, 55, 56,
    5, 6, 0, 0, 56, 57, 3, 6, 3, 0, 57, 58, 5, 7, 0, 0, 58, 60, 1, 0, 0, 0, 59, 53, 1, 0, 0, 0, 59, 54, 1, 0, 0, 0, 59,
    55, 1, 0, 0, 0, 60, 15, 1, 0, 0, 0, 5, 24, 35, 42, 50, 59,
  ];

  private static __ATN: antlr.ATN;
  public static get _ATN(): antlr.ATN {
    if (!RuleGrammarParser.__ATN) {
      RuleGrammarParser.__ATN = new antlr.ATNDeserializer().deserialize(RuleGrammarParser._serializedATN);
    }

    return RuleGrammarParser.__ATN;
  }

  private static readonly vocabulary = new antlr.Vocabulary(
    RuleGrammarParser.literalNames,
    RuleGrammarParser.symbolicNames,
    []
  );

  public override get vocabulary(): antlr.Vocabulary {
    return RuleGrammarParser.vocabulary;
  }

  private static readonly decisionsToDFA = RuleGrammarParser._ATN.decisionToState.map(
    (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index)
  );
}

export class ScriptContext extends antlr.ParserRuleContext {
  public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
    super(parent, invokingState);
  }

  public parenScript(): ParenScriptContext {
    return this.getRuleContext(0, ParenScriptContext)!;
  }

  public EOF(): antlr.TerminalNode {
    return this.getToken(RuleGrammarParser.EOF, 0)!;
  }

  public override get ruleIndex(): number {
    return RuleGrammarParser.RULE_script;
  }

  public override accept<Result>(visitor: RuleGrammarVisitor<Result>): Result | null {
    if (visitor.visitScript) {
      return visitor.visitScript(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class ParenScriptContext extends antlr.ParserRuleContext {
  public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
    super(parent, invokingState);
  }

  public LPAREN(): antlr.TerminalNode | null {
    return this.getToken(RuleGrammarParser.LPAREN, 0);
  }

  public parenScript(): ParenScriptContext | null {
    return this.getRuleContext(0, ParenScriptContext);
  }

  public RPAREN(): antlr.TerminalNode | null {
    return this.getToken(RuleGrammarParser.RPAREN, 0);
  }

  public comparison(): ComparisonContext | null {
    return this.getRuleContext(0, ComparisonContext);
  }

  public override get ruleIndex(): number {
    return RuleGrammarParser.RULE_parenScript;
  }

  public override accept<Result>(visitor: RuleGrammarVisitor<Result>): Result | null {
    if (visitor.visitParenScript) {
      return visitor.visitParenScript(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class ComparisonContext extends antlr.ParserRuleContext {
  public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
    super(parent, invokingState);
  }

  public arithmeticExpr(): ArithmeticExprContext[];
  public arithmeticExpr(i: number): ArithmeticExprContext | null;
  public arithmeticExpr(i?: number): ArithmeticExprContext[] | ArithmeticExprContext | null {
    if (i === undefined) {
      return this.getRuleContexts(ArithmeticExprContext);
    }

    return this.getRuleContext(i, ArithmeticExprContext);
  }

  public COMPARE_OP(): antlr.TerminalNode {
    return this.getToken(RuleGrammarParser.COMPARE_OP, 0)!;
  }

  public override get ruleIndex(): number {
    return RuleGrammarParser.RULE_comparison;
  }

  public override accept<Result>(visitor: RuleGrammarVisitor<Result>): Result | null {
    if (visitor.visitComparison) {
      return visitor.visitComparison(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class ArithmeticExprContext extends antlr.ParserRuleContext {
  public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
    super(parent, invokingState);
  }

  public signedAtom(): SignedAtomContext {
    return this.getRuleContext(0, SignedAtomContext)!;
  }

  public override get ruleIndex(): number {
    return RuleGrammarParser.RULE_arithmeticExpr;
  }

  public override accept<Result>(visitor: RuleGrammarVisitor<Result>): Result | null {
    if (visitor.visitArithmeticExpr) {
      return visitor.visitArithmeticExpr(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class SignedAtomContext extends antlr.ParserRuleContext {
  public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
    super(parent, invokingState);
  }

  public MINUS(): antlr.TerminalNode | null {
    return this.getToken(RuleGrammarParser.MINUS, 0);
  }

  public term(): TermContext {
    return this.getRuleContext(0, TermContext)!;
  }

  public override get ruleIndex(): number {
    return RuleGrammarParser.RULE_signedAtom;
  }

  public override accept<Result>(visitor: RuleGrammarVisitor<Result>): Result | null {
    if (visitor.visitSignedAtom) {
      return visitor.visitSignedAtom(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class TermContext extends antlr.ParserRuleContext {
  public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
    super(parent, invokingState);
  }

  public factor(): FactorContext[];
  public factor(i: number): FactorContext | null;
  public factor(i?: number): FactorContext[] | FactorContext | null {
    if (i === undefined) {
      return this.getRuleContexts(FactorContext);
    }

    return this.getRuleContext(i, FactorContext);
  }

  public PLUS(): antlr.TerminalNode[];
  public PLUS(i: number): antlr.TerminalNode | null;
  public PLUS(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    if (i === undefined) {
      return this.getTokens(RuleGrammarParser.PLUS);
    } else {
      return this.getToken(RuleGrammarParser.PLUS, i);
    }
  }

  public MINUS(): antlr.TerminalNode[];
  public MINUS(i: number): antlr.TerminalNode | null;
  public MINUS(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    if (i === undefined) {
      return this.getTokens(RuleGrammarParser.MINUS);
    } else {
      return this.getToken(RuleGrammarParser.MINUS, i);
    }
  }

  public override get ruleIndex(): number {
    return RuleGrammarParser.RULE_term;
  }

  public override accept<Result>(visitor: RuleGrammarVisitor<Result>): Result | null {
    if (visitor.visitTerm) {
      return visitor.visitTerm(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FactorContext extends antlr.ParserRuleContext {
  public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
    super(parent, invokingState);
  }

  public primary(): PrimaryContext[];
  public primary(i: number): PrimaryContext | null;
  public primary(i?: number): PrimaryContext[] | PrimaryContext | null {
    if (i === undefined) {
      return this.getRuleContexts(PrimaryContext);
    }

    return this.getRuleContext(i, PrimaryContext);
  }

  public STAR(): antlr.TerminalNode[];
  public STAR(i: number): antlr.TerminalNode | null;
  public STAR(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    if (i === undefined) {
      return this.getTokens(RuleGrammarParser.STAR);
    } else {
      return this.getToken(RuleGrammarParser.STAR, i);
    }
  }

  public SLASH(): antlr.TerminalNode[];
  public SLASH(i: number): antlr.TerminalNode | null;
  public SLASH(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    if (i === undefined) {
      return this.getTokens(RuleGrammarParser.SLASH);
    } else {
      return this.getToken(RuleGrammarParser.SLASH, i);
    }
  }

  public override get ruleIndex(): number {
    return RuleGrammarParser.RULE_factor;
  }

  public override accept<Result>(visitor: RuleGrammarVisitor<Result>): Result | null {
    if (visitor.visitFactor) {
      return visitor.visitFactor(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class PrimaryContext extends antlr.ParserRuleContext {
  public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
    super(parent, invokingState);
  }

  public TAG(): antlr.TerminalNode | null {
    return this.getToken(RuleGrammarParser.TAG, 0);
  }

  public NUMBER(): antlr.TerminalNode | null {
    return this.getToken(RuleGrammarParser.NUMBER, 0);
  }

  public LPAREN(): antlr.TerminalNode | null {
    return this.getToken(RuleGrammarParser.LPAREN, 0);
  }

  public arithmeticExpr(): ArithmeticExprContext | null {
    return this.getRuleContext(0, ArithmeticExprContext);
  }

  public RPAREN(): antlr.TerminalNode | null {
    return this.getToken(RuleGrammarParser.RPAREN, 0);
  }

  public override get ruleIndex(): number {
    return RuleGrammarParser.RULE_primary;
  }

  public override accept<Result>(visitor: RuleGrammarVisitor<Result>): Result | null {
    if (visitor.visitPrimary) {
      return visitor.visitPrimary(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
